var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServeServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-cog",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2v2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22v-2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m17 20.66-1-1.73"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10.27 7 3.34"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m20.66 17-1.73-1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m3.34 7 1.73 1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12h8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12h2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m20.66 7-1.73 1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m3.34 17 1.73-1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m17 3.34-1 1.73"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m11 13.73-4 6.93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServeServices);
export default __webpack_public_path__ + "static/media/serve-services.cb6d39807b43098e579fde8658fc0890.svg";
export { ForwardRef as ReactComponent };